import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getAllSuperadminSections({ payload }) {
  try {
    yield put(actions.addSuperadminSectionLoading(true));
    const result = yield call(api.getAllSuperadminSections);
    yield put(actions.getAllSuperadminSectionsSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getAllSuperadminSectionsFail());
  } finally {
    yield put(actions.addSuperadminSectionLoading(false));
  }
}

//Edit Tables
function* editSuperadminSection({ payload }) {
  try {
    yield put(actions.addSuperadminSectionLoading(true));
    const result = yield call(api.editSuperadminSections, payload);
    yield put(actions.editSuperadminSectionSuccess(result.data));
    toast.success("Edit Successfully");
    payload?.action && payload?.action();
  } catch (error) {
    yield put(actions.editSuperadminSectionFail());
  } finally {
    yield put(actions.addSuperadminSectionLoading(false));
  }
}

// create
function* createSuperadminSection(formData) {
  try {
    yield put(actions.addSuperadminSectionLoading(true));
    const result = yield call(api.createSuperadminSections, formData.payload);
    yield put(
      actions.createSuperadminSectionSuccess({
        data: result.data,
      })
    );
    toast.success("Created Successfully");
    formData?.action && formData?.action();
  } catch (error) {
    yield put(actions.createSuperadminSectionFail());
    toast.success(error.data.message.toString());
  } finally {
    yield put(actions.addSuperadminSectionLoading(false));
  }
}

function* deleteSuperadminSection({ payload }) {
  try {
    yield put(actions.addSuperadminSectionLoading(true));
    const result = yield call(api.deleteSuperadminSection, payload);

    yield put(actions.deleteSuperadminSectionSuccess(payload));

    toast.success("Deleted Successfully");
  } catch (error) {
    const { response, message } = error;
    toast.error(error.response);
    yield put(actions.deleteSuperadminSectionFail());
  } finally {
    yield put(actions.addSuperadminSectionLoading(false));
  }
}

function* getCourseSection({ payload }) {
  try {
    yield put(actions.addSuperadminSectionLoading(true));
    const result = yield call(api.getCourseSection, payload);
    yield put(actions.getCourseSectionSuccess(result?.data));
  } catch (error) {
    toast.error(error.response);
    yield put(actions.getCourseSectionFail());
  } finally {
    yield put(actions.addSuperadminSectionLoading(false));
  }
}
export default function* SuperadminSectionSaga() {
  yield takeLatest(
    Types.GET_SUPERADMIN_SECTIONS_REQUEST,
    getAllSuperadminSections
  );
  yield takeLatest(
    Types.SUPERADMIN_GET_COURSE_SECTION_REQUEST,
    getCourseSection
  );
  yield takeLatest(
    Types.EDIT_SUPERADMIN_SECTION_REQUEST,
    editSuperadminSection
  );
  yield takeLatest(
    Types.CREATE_SUPERADMIN_SECTION_REQUEST,
    createSuperadminSection
  );
  yield takeLatest(
    Types.DELETE_SUPERADMIN_SECTION_REQUEST,
    deleteSuperadminSection
  );
}
